import { UserProps } from '../../../constants/Common';
import type { FirebaseApi } from '../../../firebase/firebaseApi';
import { useReportsContext } from '../ReportsPageWrapper';
import { TimesheetsReportFirebaseCalls } from '../StateManagement/models';
import { TimesheetsReport } from './TimesheetsReport';

type AvailableFirebaseCalls = Extract<
	keyof FirebaseApi,
	TimesheetsReportFirebaseCalls
>;

export const TimesheetsReportWrapper = ({
	userDetails,
}: UserProps): JSX.Element => {
	const {
		context: { startDate, endDate, firebaseApi },
		dispatch,
	} = useReportsContext<AvailableFirebaseCalls>();

	return (
		<TimesheetsReport
			userDetails={userDetails}
			startDateContext={{
				date: startDate,
				setDate: (value): void => dispatch({ key: 'startDate', value }),
			}}
			endDateContext={{
				date: endDate,
				setDate: (value): void => dispatch({ key: 'endDate', value }),
			}}
			firebaseApi={firebaseApi}
		/>
	);
};
